export const theme = {
  color: {
    bg: '#0a0a0a',
    bgScrim: 'color-mix(in oklab, #0a0a0a 72%, transparent)',
    bgScrimFallback: 'rgba(10, 10, 10, 0.72)',
    fg: '#eeeae1',
    fgMuted: 'rgba(238, 234, 225, 0.55)',
    fgDim: 'rgba(238, 234, 225, 0.35)',
    fgFaint: 'rgba(238, 234, 225, 0.22)',
    border: {
      hairline: 'rgba(238, 234, 225, 0.14)',
      hairlineStrong: 'rgba(238, 234, 225, 0.25)',
    },
    focus: '#88b8ff',
    success: '#2e8f4e',
  },
  fontFamily: {
    sans: `'Geist', -apple-system, 'Helvetica Neue', sans-serif`,
    mono: `'Geist Mono', ui-monospace, monospace`,
    serif: `'Newsreader', 'Times New Roman', serif`,
  },
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
  },
  fontSize: {
    xxs: '10px',
    xs: '11px',
    sm: '13px',
    base: '15px',
    md: '16px',
    lg: '20px',
    xl: '22px',
    serifLg: '26px',
    display: 'clamp(26px, 2.6vw, 34px)',
    statement: 'clamp(26px, 2.6vw, 40px)',
  },
  lineHeight: {
    tight: 1.1,
    snug: 1.25,
    normal: 1.4,
    body: 1.5,
    loose: 1.55,
  },
  letterSpacing: {
    tightest: '-0.018em',
    tighter: '-0.015em',
    tight: '-0.01em',
    snug: '-0.005em',
    normal: '0',
    wide: '0.04em',
    wider: '0.08em',
    widest: '0.1em',
  },
  space: [0, 4, 8, 10, 12, 14, 16, 22, 24, 28, 32, 40, 48, 56, 72, 80, 110] as const,
  gutter: 'clamp(24px, 3.5vw, 48px)',
  maxWidth: {
    content: '1600px',
    prose: '70ch',
    statement: '22ch',
    hero: '540px',
  },
  navHeight: '56px',
  breakpoints: {
    sm: 640,
    md: 900,
    lg: 1200,
    xl: 1600,
  },
  zIndex: {
    base: 0,
    nav: 20,
    modal: 1000,
  },
  motion: {
    fast: '200ms',
    base: '240ms',
    slow: '500ms',
    easeOut: 'cubic-bezier(0.22, 0.8, 0.22, 1)',
  },
} as const;

export type Theme = typeof theme;
